// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/contact-id-mapping-list-schema',
  type: 'object',
  required: ['id', 'foreignAppSystemId', 'crmStateId'],
  nullable: true,
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    crmId: {
      type: 'string',
      format: 'uuid',
    },
    foreignAppSystemId: {
      type: 'integer',
    },
    foreignAppSystemKey: {
      type: 'string',
      nullable: true,
    },
    foreignId: {
      type: 'string',
      nullable: true,
    },
    crmStateId: {
      type: 'integer',
    },
    crmStateName: {
      type: 'string',
      nullable: true,
    },
    mappingStateId: {
      type: 'integer',
      nullable: true,
    },
    mappingStateName: {
      type: 'string',
      nullable: true,
    },
    mappingStateReason: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
